<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="115px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="退约原因" prop="leaveReason">
              <el-select v-model="form.leaveReason" style="width: 100%" placeholder="请选择退约原因">
                <el-option v-for="item in causeList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="床位" prop="bedName">
              <el-input clearable disabled v-model="form.bedName" placeholder="请输入床位" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="退约日期" prop="leaveDate">
              <el-date-picker style="width: 100%;" value-format="yyyy-MM-dd" :disabled="model === 'view'"
                v-model="form.leaveDate" type="date" placeholder="请选择退约日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="总退款金额" prop="refundAmount">
              <el-input clearable disabled v-model="form.refundAmount" placeholder="请输入总退款金额" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="title">收费信息</div>
      <el-table border :data="paramList" style="width: 100%" :header-cell-style="{ color: '#000' }">
        <el-table-column type="index" label="#" align="center" fixed width="50"> </el-table-column>
        <el-table-column prop="feeTypeName" label="收费项目"></el-table-column>
        <el-table-column prop="feeMonth" label="月单价"></el-table-column>
        <el-table-column prop="monthNum" label="数量/月份"></el-table-column>
        <el-table-column prop="fee" label="费用"></el-table-column>
        <el-table-column prop="backFee" label="退款金额">
          <template slot-scope="scope">
            <money-input v-model="scope.row.backFee" @input="handleInputChange(scope.$index, scope.row.backFee)"
              clearable placeholder="" style="width: 100%" />
          </template>
        </el-table-column>
        <el-table-column prop="totalPayAmount" label="实际总收费"></el-table-column>
      </el-table>
    </div>
    <div style="text-align: right">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        保存
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
<script>
import { getDictionary } from '@/api/common.js';
import {
  saveRefund,
  contractDetail
} from '../../api/serveItemManage';
export default {
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    isContract: {
      default: false,
    }
  },
  data() {
    return {
      causeList: [],
      form: {
        leaveReason: '',
        leaveDate: '',
        refundAmount: '',
        bed: '',
        bedName: '',
      },
      paramList: [],
      formRules: {
        leaveReason: [{ required: true, message: '退约原因不能为空', trigger: 'blur' }],
        leaveDate: [{ required: true, message: '退约日期不能为空', trigger: 'blur' }],
      },
    };
  },
  created() {
    this.initData();
  },
  mounted() { },
  watch: {},
  methods: {
    async initData() {
      getDictionary('nursing_leave_reason').then((res) => {
        this.causeList = res.data;
      })
      // this.form = this._.cloneDeep(this.row);
      // this.paramList = this.form.feeList || []
      contractDetail({ id: this.isContract ? this.row.contractId : this.row.id }).then((res) => {
        console.log(res, 'res');
        this.form = res.data
        this.form.leaveDate = res.data.leaveDate ? res.data.leaveDate.split(' ')[0] : ''
        this.paramList = this.form.feeList || []
        if (this.paramList.length > 0) {
          this.paramList.forEach(item => {
            item.feeType = item.feeType.toString()
            item.totalPayAmount = Number(item.fee) - Number(item.backFee)
            item.monthNum = item.monthNum && Number(item.monthNum) >= 0 ? Number(item.monthNum) : 0
          })
        }
        this.handleInputChange()
      })
    },

    handleInputChange(index, price) {
      // this.$set(this.paramList[rowIndex], 'price', price);
      // 计算总价
      if (price && Number(price) > Number(this.paramList[index].fee)) {
        // this.$message.warning('退款金额不能大于费用金额！');
        this.$set(this.paramList[index], 'backFee', this.paramList[index].fee)
      }
      let sum = this.paramList.reduce((sum, row) => {
        return sum + Number(row.backFee)
      }, 0);

      this.$set(this.form, 'refundAmount', sum)
      // if (price || 0) {
      this.paramList[index].totalPayAmount = Number(this.paramList[index].fee) - (Number(this.paramList[index].backFee) || 0)
      // }
    },

    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          let params = { nursinghomeId: this.row.nursinghomeId, elderlyId: this.isContract ? this.row.id : this.row.elderlyId, ...this.form }
          params.leaveDate = params.leaveDate ? params.leaveDate + ' 00:00:00' : ''
          saveRefund(params).then((res) => {
            this.$message.success('操作成功！');
            this.$emit('success');
          });
        }
      });
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

::v-deep .el-col-8 {
  height: 54px;
}

.title {
  line-height: 50px;
  font-weight: bolder;
  font-size: 18px;
  margin-bottom: 10px;
}

::v-deep .el-form-item__error {
  position: absolute !important;
}
</style>
